/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '',
    name: ' ',
    view: 'Home',
  },
  {
    path: '/dashboard',
    icon: 'mdi-view-dashboard',
    name: 'Dashboard',
    view: 'Dashboard',
    requireAuth: true,
    roles: ['customer', 'editor', 'admin']
  },
  {
    path: '/forms',
    icon: 'mdi-form-select',
    name: 'Forms',
    view: 'Forms',
    requireAuth: true,
    roles: ['customer', 'editor', 'admin']
  },
  {
    path: '/orders',
    icon: 'mdi-basket',
    name: 'Orders',
    view: 'Orders',
    requireAuth: true,
    roles: ['customer', 'editor', 'admin']
  },
  {
    path: '/translations',
    icon: 'mdi-translate',
    name: 'Translations',
    view: 'Translations',
    requireAuth: true,
    roles: ['customer', 'editor', 'admin']
  },
  {
    path: '/content',
    icon: 'mdi-post',
    name: 'Content',
    view: 'Content',
    requireAuth: true,
    roles: ['customer', 'editor', 'admin']
  },
  {
    path: '/mail',
    icon: 'mdi-mail',
    name: 'Mail',
    view: 'Mail',
    requireAuth: true,
    roles: ['admin']
  },
  {
    path: '/admin',
    icon: 'mdi-cog',
    name: 'Admin',
    view: 'Admin',
    requireAuth: true,
  },
  {
    path: '/schemas',
    icon: 'mdi-playlist-edit',
    name: 'Schemas',
    view: 'Schemas',
    requireAuth: true,
  },
  {
    path: '/profile',
    name: 'Profile',
    view: 'Profile',
    requireAuth: true
  },
  {
    name: 'Login',
    path: '/login',
    view: 'Login'
  }
]
